/**
 * A request to our async API that did not produce what its caller needed.
 *
 * `message` is the caller's friendly copy — the text the user sees. `problem`
 * is the PII-free machine form that telemetry records (see
 * `telemetry/failureKind.ts`): the HTTP status, or an empty body where the
 * caller needed JSON. These failures used to be plain `Error`s, so a recorded
 * one could not say whether the server answered 503, 401, or nothing at all.
 */
export class ApiRequestError extends Error {
  public readonly problem: `http-${number}` | 'empty-body';

  public constructor(message: string, problem: `http-${number}` | 'empty-body') {
    super(message);
    this.name = 'ApiRequestError';
    this.problem = problem;
  }
}
